import { Wrapper } from './styled';
import { Grid, Bones } from '@simplywallst/ui-core';

export const DividendKeyMetricsSkeleton = () => (
  <Wrapper>
    <Grid templateRows="114px" templateRowsLg="125px">
      <Bones minHeight="100%" />
    </Grid>
  </Wrapper>
);
